export default __webpack_public_path__ + "static/Stone_Arrow-63b08225be7e7ef480552e456b41a09b.png";